<template>
  <div class="edit-container">
    <van-nav-bar
      :title="`${dailyData.staffName}的月报`"
      left-arrow
      @click-left="onClickLeft"
    />
    <div class="edit-date">
      <span class="edit-label" style="padding:0">月份选择：{{reportDateStr}}</span>
      <!-- <a-date-picker v-model="reportDate" placeholder="请选择日期" value-format="YYYY-MM-DD" /> -->
      <div @click="showPicker = true">
        <span style="color: #969799;font-size: .4rem">请选择</span>
        <img style="width: 11px;height:7px" src="../assets/down.png" />
      </div>
    </div>
    <van-popup v-model="showPicker" position="bottom">
      <van-datetime-picker
        type="year-month"
        @confirm="(data) => onConfirm(data)"
        @cancel="showPicker = false"
        v-model="reportDate"
      />
    </van-popup>
    <div style="display:flex">
      <div class="edit-label" style="padding-top: 0.43rem;">任务打分</div>
      <div class="edit-label" style="padding-top: 0.43rem;">自评得分：{{selfScore}}</div>
    </div>
    <div class="position-box">
      <a-collapse v-model="activeKey1" expand-icon-position="right">
        <a-collapse-panel style="color: #333333" v-for="(i, index) in positionList1" :key="index" :header="i.name" >
          <div style="margin-bottom: .2rem" v-for="(item) in i.duties" :key="item.key">
            <div>岗位职责：{{item.dutyDesc}}</div>
            <span>任务名称：</span><a-input v-model="item.taskName" />
            <a @click="deleteTask(index,item,'position1')"><img style="width: 22px;height: 24px;margin-left: .1rem" src="../assets/delete@2x.png" /></a>
            <br />
            <span>任务权重：</span><a-input-number v-model="item.weight" :min="0" :max="100"/>%<br />
            <span>任务自评：</span><a-input-number v-model="item.selfComment" :min="0" :max="100"/><br/>
            <div><a @click="addTask(index,item,'position1')">添加任务</a></div>
          </div>
        </a-collapse-panel>
      </a-collapse>
    </div>
    <div class="edit-label" style="margin-bottom:0.27rem">工作汇报</div>
    <div class="edit-workReport">
      <a-textarea v-model="content" class="ant-textarea" />
    </div>
    <div class="file">
      <span class="edit-label" style="padding-top:0.37rem">附件：</span>
      <a-upload
        name="file"
        :multiple="true"
        :action="baseURL"
        @change="handleChange"
        :file-list="fileList"
      >
        <a-button><a-icon type="upload" />上传</a-button>
      </a-upload>
    </div>
    <span class="edit-label">下月规划</span>
    <div class="position-box">
      <a-collapse v-model="activeKey2" expand-icon-position="right">
        <a-collapse-panel style="color: #333333" v-for="(i, index) in positionList2" :key="index" :header="i.name" >
          <div style="margin-bottom: .2rem" v-for="(item) in i.duties" :key="item.key">
            <div>岗位职责：{{item.dutyDesc}}</div>
            <span>任务名称：</span><a-input v-model="item.taskName" />
            <a @click="deleteTask(index,item,'position2')"><img style="width: 22px;height: 24px;margin-left: .1rem" src="../assets/delete@2x.png" /></a>
            <br />
            <span>任务权重：</span><a-input-number v-model="item.weight" :min="0" :max="100"/>%<br />
            <!-- <span>任务自评：</span><a-input-number v-model="item.selfComment" :min="0" :max="100"/><br/> -->
            <div><a @click="addTask(index,item,'position2')">添加任务</a></div>
          </div>
        </a-collapse-panel>
      </a-collapse>
    </div>
    <div class="edit-submit" @click="submitMonthReport">提交</div>
  </div>
</template>

<script>
import { baseURL } from '../axios/index'
import { submitMonthReport, getReportPlan } from '../axios/services'
import { v4 as uuidv4 } from 'uuid';
import { mapState } from 'vuex'
import { Toast } from 'vant';
export default {
  data() {
    return {
      baseURL: baseURL + '/res/upload',
      fileList: [],
      showPicker: false,
      postOption: [
        { text: '全部', value: 0 },
        { text: '已填写', value: 1 },
        { text: '未填写', value: 2 },
        { text: '已审核', value: 3}
      ],
      postText: '',
      file: [],
      taskData: [],
      activeKey1: [],
      activeKey2: [],
      reportDate: '', // 日期
      reportDateStr: '',
      nextReportDateStr: '', // 下个月
      content: '', // 详细内容
      resourcesId: '', // 资源id
      sysStaffReportTaskList: [],
      positionList2: [],
      positionList1: [],
      selfScore: ''
    }
  },
  computed: {
    ...mapState(['dailyData'])
  },
  watch: {
    file(val) {
      let str = '';
      val?.forEach((item, index) => {
        if(index < val.length - 1) {
          str = str + item.resourcesId + ','
        }else {
          str = str + item.resourcesId
        }
      })
      this.resourcesId = str
    },
    positionList1: {
      handler(newValue, oldValue) {
        let count = 0
        this.slefScore = newValue.forEach(item => {
          if(item.duties) {
            item.duties.forEach(i => {
              let m = i.selfComment || ''
              let n = i.weight || ''
              if(m && n) count += i.selfComment * i.weight * 0.01
            })
          }
        })
        this.selfScore = count
      },
      deep: true
    }
  },
  methods: {
    onChange() {
    },
    onConfirm(data) {
      const dateTime = data.getFullYear()+'-'+this.checkTime(data.getMonth()+1)
      this.reportDateStr = dateTime;
      this.showPicker = false;
      this.handleReportDate()
    },
    checkTime(i) {
      if(i<10){ i='0'+i } return i
    },
    onClickLeft() {
      window.history.go(-1)
    },
    handleChange(info) {
      this.fileList = info.fileList;
      this.file = info.fileList.map(item => item.response?.data)
    },
    addTask(index, item, position) {
      const param = Object.assign({}, item)
      for(let m in param) {
        if(m == 'taskName' || m == 'selfComment' || m == 'weight') {
          param[m] = ''
        }
      }
      param.key = uuidv4()
      if(position === 'position1') {
        this.positionList1[index].duties.push(param)
      }
      if(position === 'position2') {
        this.positionList2[index].duties.push(param)
      }
      this.$forceUpdate()
    },
    deleteTask(index, item, position) {
      if(position === 'position1') {
        this.positionList1[index].duties = this.positionList1[0].duties.filter(i => i.key !== item.key)
      }
      if(position === 'position2') {
        this.positionList2[index].duties = this.positionList2[0].duties.filter(i => i.key !== item.key)
      }
      this.$forceUpdate()
    },
    handleReportDate() {
      if(this.reportDate.getMonth() == 11) {
        this.nextReportDateStr = Number(this.reportDate.getFullYear()) + 1 + '-01'
      }
      else if(this.reportDate.getMonth() < 9){
        this.nextReportDateStr = this.reportDate.getFullYear() + '-0' + Number(this.reportDate.getMonth() +2)
      }else{
        this.nextReportDateStr = this.reportDate.getFullYear() + '-' + Number(this.reportDate.getMonth() +2)
      }
    },
    submitMonthReport() {
      let arr1 = [];
      let arr2 = [];
      let array = []
      let flag = false;
      for(let i = 0; i < this.positionList1.length; i++) {
        this.positionList1[i].duties?.forEach(item => {
          arr1.push(item)
        })
      }
      for(let i = 0; i < this.positionList2.length; i++) {
        this.positionList2[i].duties?.forEach(item => {
          arr2.push(item)
        })
      }
      arr1.forEach(item => {
        if(!item.taskName === '' || !item.selfComment || !item.weight) {
          Toast('没填写任务名称或者没填写自评分数或者没填写任务权重')
          flag = true
        }
      })
      arr2.forEach(item => {
        if(!item.taskName === ''|| !item.weight) {
          Toast('没填写任务名称或者没填写任务权重')
          flag = true
        }
      })
      if(flag) return
      if(!this.reportDate) return Toast('没有填写日期')
      const params1 = {
        staffId: this.dailyData.staffId,
        staffName: this.dailyData.staffName,
        officeId: this.dailyData.officeId,
        officeName: this.dailyData.officeName,
        companyId: this.dailyData.companyId,
        reportDate: this.reportDateStr,
        resourcesId: this.resourcesId,
        content: this.content,
        reportType: '3',
        monthlyType: '1',
        sysStaffReportTaskList: arr1
      }
      const params2 = {
        staffId: this.dailyData.staffId,
        staffName: this.dailyData.staffName,
        officeId: this.dailyData.officeId,
        officeName: this.dailyData.officeName,
        companyId: this.dailyData.companyId,
        reportDate: this.nextReportDateStr,
        resourcesId: this.resourcesId,
        content: this.content,
        reportType: '3',
        monthlyType: '2',
        sysStaffReportTaskList: arr2
      }
      array = [params1,params2]
      submitMonthReport(array).then(res => {
        if(res.data.code === 0) {
          this.$router.push('/month-report')
        }else {
          Toast.fail(res.data.msg)
        }
      })
    },
    getElementOffsetTop(el) {
      let top = el.offsetTop
      let cur = el.offsetParent
      while(cur != null){
        top += cur.offsetTop
        cur = cur.offsetParent
      }
      return top
    },
    getReportPlan() {
      const date= new Date()
      const dateTime = date.getFullYear()+'-'+this.checkTime(date.getMonth()+1)
      const params = {
        staffId: this.dailyData.staffId,
        reportDate: dateTime
      }
      getReportPlan(params).then(res => {
        if(res.data.code === 0) {
          if(res.data.data.sysStaffReportTaskList && res.data.data.sysStaffReportTaskList.length > 0) {
            this.positionList1.map(item => {
              if(item.duties != []) {
                item.duties.forEach(i => {
                  res.data.data.sysStaffReportTaskList.forEach(m => {
                    if(m.dutyId === i.dutyId) {
                      i.key = uuidv4();
                      i.dutyDesc = m.dutyDesc
                      i.dutyId = m.dutyId
                      i.postName = m.postName
                      i.reportId = m.reportId
                      i.taskId = m.taskId
                      i.taskName = m.taskName
                      i.weight = m.weight
                    }
                  })
                })
                return {...item, key: uuidv4()}
              }
              else {
                return {...item, key: uuidv4()}
              }
            })
          }
        }else {
          Toast.fail(res.data.msg)
        }
      })
    }
  },
  created() {
    const date= new Date()
    const dateTime = date.getFullYear()+'-'+this.checkTime(date.getMonth()+1)
    this.reportDate = new Date()
    this.reportDateStr = dateTime
    this.handleReportDate()
    this.positionList1 = JSON.parse(JSON.stringify(this.dailyData.positions?.map(item => {
      if(item.duties !== []) {
        item.duties.forEach(i => {
          i.key = uuidv4();
          i.postName = item.name
          i.dutyDesc = i.description
        })
        return {...item, key: uuidv4()}
      }else {
        return {...item, key: uuidv4()}
      }
    })))
    this.positionList2 = JSON.parse(JSON.stringify(this.dailyData.positions?.map(item => {
      if(item.duties !== []) {
        item.duties.forEach(i => {
          i.key = uuidv4();
          i.postName = item.name
          i.dutyDesc = i.description
        })
        return {...item, key: uuidv4()}
      }else {
        return {...item, key: uuidv4()}
      }
    })))
    this.activeKey1 = this.positionList1.map((item,index) => {
      return index
    })
    this.activeKey2 = this.positionList2.map((item,index) => {
      return index
    })
    this.getReportPlan()
  },
}
</script>

<style scoped>
  .edit-container {
    width: 100%;
    background: #f9f9f9;
    min-height: 100vh;
    padding-bottom:2rem;
    padding-top: 1.17rem;
    position: relative;
  }
  .edit-container /deep/ .van-nav-bar {
    background: inherit;
    width: 100%;
    height: 1.17rem;
    background: #ffffff;
    position: fixed;
    top: 0;
    left: 0;
  }
  .van-hairline--bottom::after {
    border: none;
  }
  .van-nav-bar /deep/ .van-nav-bar__left {
    padding: .4rem !important;
  }
  .van-nav-bar /deep/ .van-nav-bar__arrow {
    font-size: 24px !important;
    color: black;
  }
  .edit-date {
    height: 1.28rem;
    padding: .4rem;
    background: #FFFFFF;
    box-shadow: 0rem 0.05rem 0.11rem 0rem #F2F3F5;
    display: flex;
    justify-content: space-between;
  }
  .edit-label {
    font-size: 0.43rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #323233;
    padding-left: 0.4rem;
  }
  .position-box {
    padding: .4rem;
    padding-top: .27rem;
    border-radius: 0rem;
    box-shadow: 0rem 0rem 0rem 0rem #f2f3f5;
  }
  .ant-collapse-item /deep/.ant-collapse-header {
    width: 100%;
    height: 1rem;
    padding: .2rem !important;
    color: inherit;
  }
  .ant-collapse {
    background: none !important;
    overflow: hidden;
  }
  .ant-collapse-item /deep/ .ant-collapse-header {
    background-color: #ffffff;
  }
  .ant-collapse-item /deep/ .ant-collapse-content-box {
    padding: 10px !important;
  }
  .van-dropdown-menu {
    /* width: 1rem; */
    height: .8rem;
  }
  .van-dropdown-menu__item {
    /* width: 1rem; */
    height: .8rem;
  }
  .ant-input {
    width: 60%;
    margin-bottom: .2rem;
  }
  .ant-input-number {
    width: 60%;
    margin-bottom: .2rem;
  }
  .ant-textarea {
    width: calc(100vw - .8rem);
    margin-left: .4rem;
    min-height: 5rem;
    height: 100%;
  }
  .file {
    margin: .53rem auto;
    width: calc(100vw - .8rem);
    height: 3rem;
    background: #ffffff;
    border-radius: 4px;
    box-shadow: 0rem 0rem 0rem 0rem #f2f3f5;
  }
  .edit-submit{
    width: 8.29rem;
    height: 1.17rem;
    background: #1584FF;
    box-shadow: 0rem 0.05rem 0.21rem 0rem #80BCFF;
    border-radius: 0.21rem;
    color: white;
    line-height: 1.17rem;
    text-align: center;
    position:fixed;
    bottom: 0.32rem;
    left: 0.85rem;
  }
</style>